import type { ReactElement } from 'react';
import { Link } from '../../../../app/di';

/** Посты, в которых используется медиа (MED-UC-3) или которые мешают его удалить (MED-UC-5.CC-1). */
export function PostLinks({ blogId, posts, empty }: { blogId: string; posts: readonly { id: string; title: string }[]; empty?: string }): ReactElement | null {
  if (posts.length === 0) return empty ? <p className="u-muted">{empty}</p> : null;
  return (
    <ul className="u-bullets">
      {posts.map((post) => (
        <li key={post.id}>
          <Link to="post" params={{ blogId, postId: post.id }}>
            {post.title}
          </Link>
        </li>
      ))}
    </ul>
  );
}
